// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Env from "../../core/Env.res.js";
import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Json from "../../primitives/Json.res.js";
import * as Uuid from "../../externals/Uuid.res.js";
import * as Future from "rescript-future/src/Future.res.js";
import * as Request from "../../core/Request.res.js";
import * as JsonCodec from "../../primitives/JsonCodec.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as FuturePromise from "rescript-future/src/FuturePromise.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as UserPreferences from "../../core/UserPreferences.res.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";

let RequestProductType = {};

let RequestSheetLabelsType = {};

let values = [
  "Hidden",
  "SKU",
  "InternalCode"
];

function toString(value) {
  switch (value) {
    case "Hidden" :
      return "Hidden";
    case "SKU" :
      return "SKU";
    case "InternalCode" :
      return "InternalCode";
  }
}

function fromString(value) {
  switch (value) {
    case "Hidden" :
      return {
        TAG: "Ok",
        _0: "Hidden"
      };
    case "InternalCode" :
      return {
        TAG: "Ok",
        _0: "InternalCode"
      };
    case "SKU" :
      return {
        TAG: "Ok",
        _0: "SKU"
      };
    default:
      return {
        TAG: "Error",
        _0: undefined
      };
  }
}

function toLabel(value) {
  switch (value) {
    case "Hidden" :
      return I18n.t("Do not display additional product codes");
    case "SKU" :
      return I18n.t("Display SKU");
    case "InternalCode" :
      return I18n.t("Display internal code");
  }
}

let ProductCode = {
  values: values,
  toString: toString,
  fromString: fromString,
  toLabel: toLabel
};

let endpoint = Env.gatewayUrl() + "/barcode-completions";

function encodeBodyJson(productsValues, shopId) {
  if (typeof productsValues === "object" && productsValues._0.length === 0) {
    return {
      TAG: "Error",
      _0: I18n.t("Products list empty, please select at least one product before continuing")
    };
  }
  let dict = {};
  if (typeof productsValues !== "object") {
    dict["shopId"] = shopId;
  } else {
    dict["shopId"] = shopId;
    dict["variantIds"] = productsValues._0.map(param => param.variantId);
  }
  return {
    TAG: "Ok",
    _0: dict
  };
}

function make(bodyJson) {
  return Request.make(endpoint, "POST", {
    TAG: "JsonBody",
    _0: bodyJson
  }, undefined, true);
}

let BarcodeCompletionRequest = {
  endpoint: endpoint,
  encodeBodyJson: encodeBodyJson,
  make: make
};

function toString$1(value) {
  if (value === "Grid21") {
    return "Grid21";
  } else {
    return "Grid64";
  }
}

function fromString$1(value) {
  switch (value) {
    case "Grid21" :
      return {
        TAG: "Ok",
        _0: "Grid21"
      };
    case "Grid64" :
      return {
        TAG: "Ok",
        _0: "Grid64"
      };
    default:
      return {
        TAG: "Error",
        _0: undefined
      };
  }
}

function toMaxOffset(value) {
  if (value === "Grid21") {
    return 21;
  } else {
    return 64;
  }
}

function toFormatLabel(value) {
  if (value === "Grid21") {
    return "6,35 x 3,81 cm";
  } else {
    return "4,57 x 1,68 cm";
  }
}

function toLabel$1(value) {
  return I18n.template(I18n.t("Sheet of {{number}} labels (format {{format}})"), {
    number: toMaxOffset(value),
    format: toFormatLabel(value)
  }, undefined);
}

let LabelFormat = {
  toString: toString$1,
  fromString: fromString$1,
  toMaxOffset: toMaxOffset,
  toFormatLabel: toFormatLabel,
  toLabel: toLabel$1
};

let values$1 = [
  "Unsorted",
  "AscProductName",
  "AscProductCategory"
];

function toString$2(value) {
  switch (value) {
    case "Unsorted" :
      return "Unsorted";
    case "AscProductName" :
      return "AscProductName";
    case "AscProductCategory" :
      return "AscProductCategory";
  }
}

function fromString$2(value) {
  switch (value) {
    case "AscProductCategory" :
      return {
        TAG: "Ok",
        _0: "AscProductCategory"
      };
    case "AscProductName" :
      return {
        TAG: "Ok",
        _0: "AscProductName"
      };
    case "Unsorted" :
      return {
        TAG: "Ok",
        _0: "Unsorted"
      };
    default:
      return {
        TAG: "Error",
        _0: undefined
      };
  }
}

function toLabel$2(value) {
  switch (value) {
    case "Unsorted" :
      return I18n.t("Do not sort");
    case "AscProductName" :
      return I18n.t("Sort alphabetically by product name");
    case "AscProductCategory" :
      return I18n.t("Sort alphabetically by product category");
  }
}

let LabelSort = {
  values: values$1,
  toString: toString$2,
  fromString: fromString$2,
  toLabel: toLabel$2
};

let endpoint$1 = Env.pdfUrl() + "/variant-labels";

function encodeBodyJson$1(productsValues, priceId, productBarcodeDisplayed, priceDisplayed, producerDisplayed, alcoholVolumeDisplayed, designationDisplayed, productCode, labelFormat, printOffset, borderEnabled, sort) {
  if (typeof productsValues === "object" && productsValues._0.length === 0) {
    return {
      TAG: "Error",
      _0: I18n.t("Products list empty, please select at least one product before continuing")
    };
  }
  let dict = {};
  dict["priceId"] = Json.encodeString(priceId);
  dict["barcodeEnabled"] = Json.encodeBoolean(productBarcodeDisplayed);
  dict["priceEnabled"] = Json.encodeBoolean(priceDisplayed);
  dict["producerEnabled"] = Json.encodeBoolean(producerDisplayed);
  dict["alcoholVolumeEnabled"] = Json.encodeBoolean(alcoholVolumeDisplayed);
  dict["designationEnabled"] = Json.encodeBoolean(designationDisplayed);
  dict["borderEnabled"] = Json.encodeBoolean(borderEnabled);
  dict["offsetLabel"] = Json.encodeNumber(printOffset);
  switch (productCode) {
    case "Hidden" :
      break;
    case "SKU" :
      dict["labelCodeKind"] = Json.encodeString("SKU");
      break;
    case "InternalCode" :
      dict["labelCodeKind"] = Json.encodeString("INTERNAL_CODE");
      break;
  }
  if (labelFormat === "Grid21") {
    dict["labelsPerPage"] = Json.encodeString("A4_21");
  } else {
    dict["labelsPerPage"] = Json.encodeString("A4_64");
  }
  switch (sort) {
    case "Unsorted" :
      break;
    case "AscProductName" :
      dict["labelSorting"] = Json.encodeString("ASC_PRODUCT_NAME");
      break;
    case "AscProductCategory" :
      dict["labelSorting"] = Json.encodeString("ASC_CATEGORY");
      break;
  }
  if (typeof productsValues === "object") {
    let items = productsValues._0.map(param => Object.fromEntries([
      [
        "variantId",
        Json.encodeString(param.variantId)
      ],
      [
        "repetitions",
        Json.encodeNumber(param.repetitions)
      ]
    ]));
    dict["items"] = Json.encodeArray(items);
  }
  return {
    TAG: "Ok",
    _0: Json.encodeDict(dict)
  };
}

function decodeUrl(json) {
  return Json.flatDecodeDictFieldString(json, "url");
}

function decodeInvalidBarcodesVariants(json) {
  return Stdlib_Option.map(Json.flatDecodeDictFieldArray(json, "invalidBarcodes"), invalidBarcodes => Stdlib_Array.filterMap(invalidBarcodes, item => {
    let variantId = Json.flatDecodeDictFieldString(Json.decodeDict(item), "variantId");
    let productName = Json.flatDecodeDictFieldString(Json.decodeDict(item), "productName");
    let variantName = Json.flatDecodeDictFieldString(Json.decodeDict(item), "variantName");
    if (variantId !== undefined && productName !== undefined && variantName !== undefined) {
      return {
        id: variantId,
        productName: productName,
        name: variantName
      };
    }
  }));
}

function decodeBodyJson(result) {
  let val;
  try {
    val = Stdlib_Option.map(Stdlib_Option.map(Json.decodeDict(result), data => [
      Json.flatDecodeDictFieldString(data, "url"),
      decodeInvalidBarcodesVariants(data)
    ]), param => [
      Stdlib_Option.map(param[0], prim => new URL(prim)),
      param[1]
    ]);
  } catch (exn) {
    return {
      TAG: "Error",
      _0: undefined
    };
  }
  if (val === undefined) {
    return {
      TAG: "Error",
      _0: undefined
    };
  }
  let url = val[0];
  if (url === undefined) {
    return {
      TAG: "Error",
      _0: undefined
    };
  }
  let variants = val[1];
  if (variants === undefined) {
    return {
      TAG: "Error",
      _0: undefined
    };
  }
  let url$1 = Primitive_option.valFromOption(url);
  if (url$1.protocol === "https:") {
    return {
      TAG: "Ok",
      _0: {
        url: url$1,
        invalidBarcodesVariants: variants
      }
    };
  } else {
    return {
      TAG: "Error",
      _0: undefined
    };
  }
}

function make$1(bodyJson) {
  return Request.make(endpoint$1, "POST", {
    TAG: "JsonBody",
    _0: bodyJson
  }, undefined, true);
}

let LabelsRequest = {
  endpoint: endpoint$1,
  encodeBodyJson: encodeBodyJson$1,
  decodeUrl: decodeUrl,
  decodeInvalidBarcodesVariants: decodeInvalidBarcodesVariants,
  decodeBodyJson: decodeBodyJson,
  make: make$1
};

function make$2(requestBarcodeCompletion, requestLabelsGenerating, productsValues, priceId, missingProductBarcodeGenerated, productBarcodeDisplayed, priceDisplayed, producerDisplayed, alcoholVolumeDisplayed, designationDisplayed, productCode, labelFormat, printOffset, borderEnabled, sort, shopId) {
  let variantLabelBodyJson = encodeBodyJson$1(productsValues, priceId, productBarcodeDisplayed, priceDisplayed, producerDisplayed, alcoholVolumeDisplayed, designationDisplayed, productCode, labelFormat, printOffset, borderEnabled, sort);
  if (variantLabelBodyJson.TAG !== "Ok") {
    return Future.value({
      TAG: "Error",
      _0: variantLabelBodyJson._0
    });
  }
  let variantLabelBodyJson$1 = variantLabelBodyJson._0;
  let preRequestBarcodeCompletion;
  if (missingProductBarcodeGenerated) {
    let barcodeCompletionBodyJson = encodeBodyJson(productsValues, shopId);
    preRequestBarcodeCompletion = barcodeCompletionBodyJson.TAG === "Ok" ? Future.mapError(Future.mapOk(requestBarcodeCompletion(barcodeCompletionBodyJson._0), undefined, param => {}), undefined, param => {}) : Future.value({
        TAG: "Error",
        _0: undefined
      });
  } else {
    preRequestBarcodeCompletion = Future.value({
      TAG: "Ok",
      _0: undefined
    });
  }
  return Future.mapError(Future.mapOk(Future.flatMapOk(preRequestBarcodeCompletion, undefined, () => Future.map(requestLabelsGenerating(variantLabelBodyJson$1), undefined, result => {
    if (result.TAG === "Ok") {
      return decodeBodyJson(result._0);
    } else {
      return {
        TAG: "Error",
        _0: undefined
      };
    }
  })), undefined, result => result), undefined, () => I18n.t("An unexpected error occured. Please try again or contact the support."));
}

let CombineRequests = {
  make: make$2
};

let Sheet = {
  LabelFormat: LabelFormat,
  LabelSort: LabelSort,
  LabelsRequest: LabelsRequest,
  CombineRequests: CombineRequests
};

function toString$3(value) {
  if (value === "Label31x22") {
    return "Label31x22";
  } else {
    return "Label57x19";
  }
}

function fromString$3(value) {
  switch (value) {
    case "Label31x22" :
      return {
        TAG: "Ok",
        _0: "Label31x22"
      };
    case "Label57x19" :
      return {
        TAG: "Ok",
        _0: "Label57x19"
      };
    default:
      return {
        TAG: "Error",
        _0: undefined
      };
  }
}

function toFormatLabel$1(value) {
  if (value === "Label31x22") {
    return "3,10 x 2,20 cm";
  } else {
    return "5,70 x 1,90 cm";
  }
}

function toLabel$3(value) {
  return I18n.template(I18n.t("Unit label (format {{format}})"), {
    format: toFormatLabel$1(value)
  }, undefined);
}

let LabelFormat$1 = {
  toString: toString$3,
  fromString: fromString$3,
  toFormatLabel: toFormatLabel$1,
  toLabel: toLabel$3
};

let printersHubName = "StarPrintersHub";

function endpoint$2(shopId) {
  return Env.gatewayUrl() + "/printers-hub/" + printersHubName + "/" + shopId + "/default-printer";
}

function decodeInvalidRequestFailure(error) {
  if (error.kind === "NotFoundShopDefaultPrinterConfig") {
    return "NoPrinterFound";
  } else {
    return "UnexpectedFailure";
  }
}

function futureMapResult(futureResult) {
  return Future.mapError(Future.mapOk(futureResult, undefined, param => {}), undefined, error => {
    if (typeof error !== "object" || error.TAG !== "InvalidRequestFailures") {
      return "UnexpectedFailure";
    } else {
      return Stdlib_Option.getOr(Stdlib_Option.map(error._0[0], decodeInvalidRequestFailure), "UnexpectedFailure");
    }
  });
}

function make$3(shopId) {
  return futureMapResult(Request.make(endpoint$2(shopId), "GET", undefined, undefined, undefined));
}

let DefaultPrinterRequest = {
  endpoint: endpoint$2,
  decodeInvalidRequestFailure: decodeInvalidRequestFailure,
  futureMapResult: futureMapResult,
  make: make$3
};

function endpoint$3(shopId) {
  return Env.gatewayUrl() + (`/printers-hub/` + printersHubName + `/` + shopId + `/print-variants-labels`);
}

function encodeBodyJson$2(priceId, productCode, productBarcodeDisplayed, priceDisplayed, producerDisplayed, alcoholVolumeDisplayed, designationDisplayed, labelFormat, productsValues) {
  if (typeof productsValues === "object" && productsValues._0.length === 0) {
    return {
      TAG: "Error",
      _0: I18n.t("Products list empty, please select at least one product before continuing")
    };
  }
  let dict = {};
  dict["priceId"] = Json.encodeString(priceId);
  dict["barcodeEnabled"] = Json.encodeBoolean(productBarcodeDisplayed);
  dict["priceEnabled"] = Json.encodeBoolean(priceDisplayed);
  dict["producerEnabled"] = Json.encodeBoolean(producerDisplayed);
  dict["alcoholVolumeEnabled"] = Json.encodeBoolean(alcoholVolumeDisplayed);
  dict["designationEnabled"] = Json.encodeBoolean(designationDisplayed);
  switch (productCode) {
    case "Hidden" :
      break;
    case "SKU" :
      dict["labelCodeKind"] = Json.encodeString("SKU");
      break;
    case "InternalCode" :
      dict["labelCodeKind"] = Json.encodeString("INTERNAL_CODE");
      break;
  }
  if (labelFormat === "Label31x22") {
    dict["labelFormat"] = Json.encodeString("W31_X_H22");
  }
  if (typeof productsValues === "object") {
    let items = productsValues._0.map(param => Object.fromEntries([
      [
        "variantId",
        Json.encodeString(param.variantId)
      ],
      [
        "repetitions",
        Json.encodeNumber(param.repetitions)
      ]
    ]));
    dict["items"] = Json.encodeArray(items);
  }
  return {
    TAG: "Ok",
    _0: Json.encodeDict(dict)
  };
}

function decodeInvalidRequestFailure$1(serverFailure) {
  let match = serverFailure.kind;
  switch (match) {
    case "InvalidVariantLabelPrice" :
    case "NotFoundPriceForVariant" :
      return "PriceUnknown";
    default:
      return "Unknown";
  }
}

function parseAndDecodeError(string) {
  let json;
  try {
    json = Json.parseExn(string);
  } catch (exn) {
    return "Unknown";
  }
  let match = Request.decodeResult(json);
  if (match.TAG === "Ok") {
    return;
  }
  let serverFailures = match._0;
  if (serverFailures !== undefined) {
    return Stdlib_Option.map(serverFailures[0], decodeInvalidRequestFailure$1);
  }
}

function make$4(bodyJson, shopId) {
  let jwt = Auth.getJwt();
  if (jwt !== undefined) {
    return Future.map(FuturePromise.fromPromise(fetch(endpoint$3(shopId), {
      method: "POST",
      body: Primitive_option.some(Json.stringify(bodyJson)),
      headers: Primitive_option.some(new Headers({
        "Content-Type": "application/json",
        Authorization: `Bearer ` + jwt
      }))
    }).then(prim => prim.text())), undefined, result => {
      if (result.TAG !== "Ok") {
        return {
          TAG: "Error",
          _0: "Unknown"
        };
      }
      let errorTextResponse = result._0;
      if (errorTextResponse === "OK") {
        return {
          TAG: "Ok",
          _0: undefined
        };
      } else {
        return {
          TAG: "Error",
          _0: Stdlib_Option.getOr(parseAndDecodeError(errorTextResponse), "Unknown")
        };
      }
    });
  } else {
    return Future.value({
      TAG: "Error",
      _0: "Unknown"
    });
  }
}

let LabelsRequest$1 = {
  endpoint: endpoint$3,
  encodeBodyJson: encodeBodyJson$2,
  decodeInvalidRequestFailure: decodeInvalidRequestFailure$1,
  parseAndDecodeError: parseAndDecodeError,
  make: make$4
};

function make$5(requestBarcodeCompletion, requestLabelsPrinting, priceId, priceName, productCode, productBarcodeDisplayed, productsValues, labelFormat, missingProductBarcodeGenerated, priceDisplayed, producerDisplayed, alcoholVolumeDisplayed, designationDisplayed, shopId) {
  let bodyJson = encodeBodyJson$2(priceId, productCode, productBarcodeDisplayed, priceDisplayed, producerDisplayed, alcoholVolumeDisplayed, designationDisplayed, labelFormat, productsValues);
  if (bodyJson.TAG !== "Ok") {
    return Future.value({
      TAG: "Error",
      _0: bodyJson._0
    });
  }
  let bodyJson$1 = bodyJson._0;
  let preRequestBarcodeCompletion;
  if (missingProductBarcodeGenerated) {
    let barcodeCompletionBodyJson = encodeBodyJson(productsValues, shopId);
    preRequestBarcodeCompletion = barcodeCompletionBodyJson.TAG === "Ok" ? Future.mapError(Future.mapOk(requestBarcodeCompletion(barcodeCompletionBodyJson._0), undefined, param => {}), undefined, param => {}) : Future.value({
        TAG: "Error",
        _0: undefined
      });
  } else {
    preRequestBarcodeCompletion = Future.value({
      TAG: "Ok",
      _0: undefined
    });
  }
  return Future.mapError(Future.flatMapOk(Future.mapError(preRequestBarcodeCompletion, undefined, () => "Unknown"), undefined, () => requestLabelsPrinting(bodyJson$1, shopId)), undefined, serverFailure => {
    if (serverFailure === "PriceUnknown") {
      return I18n.template(I18n.t("The label printing has failed: please enter the retail price for the price list set up for printing ({{priceName}})."), {
        priceName: priceName
      }, undefined);
    } else {
      return I18n.t("An unexpected error occured. Please try again or contact the support.");
    }
  });
}

let CombineRequests$1 = {
  make: make$5
};

let Print = {
  LabelFormat: LabelFormat$1,
  printersHubName: printersHubName,
  DefaultPrinterRequest: DefaultPrinterRequest,
  LabelsRequest: LabelsRequest$1,
  CombineRequests: CombineRequests$1
};

function toString$4(polyValue) {
  if (polyValue.TAG === "LabelSheet") {
    return toString$1(polyValue._0);
  } else {
    return toString$3(polyValue._0);
  }
}

function fromString$4(value) {
  let match = fromString$1(value);
  let match$1 = fromString$3(value);
  if (match.TAG === "Ok") {
    return {
      TAG: "LabelSheet",
      _0: {
        TAG: "Ok",
        _0: match._0
      }
    };
  } else if (match$1.TAG === "Ok") {
    return {
      TAG: "LabelPrint",
      _0: {
        TAG: "Ok",
        _0: match$1._0
      }
    };
  } else {
    return {
      TAG: "LabelPrint",
      _0: {
        TAG: "Error",
        _0: undefined
      }
    };
  }
}

let GlobalLabelFormat = {
  toString: toString$4,
  fromString: fromString$4
};

let jsonCodec = JsonCodec.object13(param => [
  param.priceId,
  param.priceName,
  param.productBarcodeDisplayed,
  param.missingProductBarcodeGenerated,
  param.priceDisplayed,
  param.producerDisplayed,
  param.alcoholVolumeDisplayed,
  param.designationDisplayed,
  toString(param.productCode),
  toString$4(param.labelFormat),
  param.printOffset,
  param.borderEnabled,
  toString$2(param.sort)
], param => {
  let borderEnabled = param[11];
  let printOffset = param[10];
  let designationDisplayed = param[7];
  let alcoholVolumeDisplayed = param[6];
  let producerDisplayed = param[5];
  let priceDisplayed = param[4];
  let missingProductBarcodeGenerated = param[3];
  let productBarcodeDisplayed = param[2];
  let priceName = param[1];
  let match = Uuid.fromString(param[0]);
  let match$1 = fromString(param[8]);
  let match$2 = fromString$4(param[9]);
  let match$3 = fromString$2(param[12]);
  if (match === undefined) {
    return {
      TAG: "Error",
      _0: {
        NAME: "SyntaxError",
        VAL: "Could not decode"
      }
    };
  }
  let priceId = Primitive_option.valFromOption(match);
  if (match$1.TAG !== "Ok") {
    return {
      TAG: "Error",
      _0: {
        NAME: "SyntaxError",
        VAL: "Could not decode"
      }
    };
  }
  let productCode = match$1._0;
  if (match$2.TAG === "LabelSheet") {
    let labelFormat = match$2._0;
    if (labelFormat.TAG === "Ok" && match$3.TAG === "Ok") {
      return {
        TAG: "Ok",
        _0: {
          priceId: priceId,
          priceName: priceName,
          productBarcodeDisplayed: productBarcodeDisplayed,
          missingProductBarcodeGenerated: missingProductBarcodeGenerated,
          priceDisplayed: priceDisplayed,
          producerDisplayed: producerDisplayed,
          alcoholVolumeDisplayed: alcoholVolumeDisplayed,
          designationDisplayed: designationDisplayed,
          productCode: productCode,
          labelFormat: {
            TAG: "LabelSheet",
            _0: labelFormat._0
          },
          printOffset: printOffset,
          borderEnabled: borderEnabled,
          sort: match$3._0
        }
      };
    } else {
      return {
        TAG: "Error",
        _0: {
          NAME: "SyntaxError",
          VAL: "Could not decode"
        }
      };
    }
  }
  let labelFormat$1 = match$2._0;
  if (labelFormat$1.TAG === "Ok" && match$3.TAG === "Ok") {
    return {
      TAG: "Ok",
      _0: {
        priceId: priceId,
        priceName: priceName,
        productBarcodeDisplayed: productBarcodeDisplayed,
        missingProductBarcodeGenerated: missingProductBarcodeGenerated,
        priceDisplayed: priceDisplayed,
        producerDisplayed: producerDisplayed,
        alcoholVolumeDisplayed: alcoholVolumeDisplayed,
        designationDisplayed: designationDisplayed,
        productCode: productCode,
        labelFormat: {
          TAG: "LabelPrint",
          _0: labelFormat$1._0
        },
        printOffset: printOffset,
        borderEnabled: borderEnabled,
        sort: match$3._0
      }
    };
  } else {
    return {
      TAG: "Error",
      _0: {
        NAME: "SyntaxError",
        VAL: "Could not decode"
      }
    };
  }
}, JsonCodec.field("priceId", JsonCodec.string), JsonCodec.field("priceName", JsonCodec.string), JsonCodec.field("productBarcodeDisplayed", JsonCodec.bool), JsonCodec.field("missingProductBarcodeGenerated", JsonCodec.bool), JsonCodec.field("priceDisplayed", JsonCodec.bool), JsonCodec.field("producerDisplayed", JsonCodec.bool), JsonCodec.field("alcoholVolumeDisplayed", JsonCodec.bool), JsonCodec.field("designationDisplayed", JsonCodec.bool), JsonCodec.field("productCode", JsonCodec.string), JsonCodec.field("labelFormat", JsonCodec.string), JsonCodec.field("printOffset", JsonCodec.int), JsonCodec.field("borderEnabled", JsonCodec.bool), JsonCodec.field("sort", JsonCodec.string));

function encoder(state) {
  return JsonCodec.encodeWith(state, jsonCodec);
}

function decoder(json) {
  return JsonCodec.decodeWith(json, jsonCodec);
}

function useRead() {
  return UserPreferences.useRead("catalog-labels-options", decoder);
}

let StateSettingsUserPreferences = {
  GlobalLabelFormat: GlobalLabelFormat,
  jsonCodec: jsonCodec,
  encoder: encoder,
  decoder: decoder,
  useRead: useRead
};

export {
  RequestProductType,
  RequestSheetLabelsType,
  ProductCode,
  BarcodeCompletionRequest,
  Sheet,
  Print,
  StateSettingsUserPreferences,
}
/* endpoint Not a pure module */
